import { render, staticRenderFns } from "./ConfirmLogout.vue?vue&type=template&id=4e488ebc&scoped=true&"
import script from "./ConfirmLogout.vue?vue&type=script&lang=js&"
export * from "./ConfirmLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e488ebc",
  null
  
)

export default component.exports